import { render, staticRenderFns } from "./CytomineTask.vue?vue&type=template&id=6fc124ef&scoped=true&"
import script from "./CytomineTask.vue?vue&type=script&lang=js&"
export * from "./CytomineTask.vue?vue&type=script&lang=js&"
import style0 from "./CytomineTask.vue?vue&type=style&index=0&id=6fc124ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc124ef",
  null
  
)

export default component.exports